import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ContentArticle from '../ContentArticle'
import Content from '../Content'
import SummaryPage from '../SummaryPage'

import Insights from '@healthwise-ui/content/Insights'
import Button from '@healthwise-ui/core/Button'

class Topic extends Component {
  constructor(props) {
    super(props)

    this.navigateToTab = this.navigateToTab.bind(this)

    this.insights = new Insights()
  }

  componentDidMount() {
    this.scrollToHashId()
  }

  componentDidUpdate() {
    this.scrollToHashId()
  }

  // emulate URL anchor scroll functionality in our architecture
  scrollToHashId() {
    const removeHash = this.removeHash
    // get URL hash (minus the hash mark)
    const hash = window.location.hash.substring(1)

    // if there's a hash, scroll to that ID
    if (hash && hash.length) {
      // setTimeout and requestAnimationFrame help ensure a true DOM repaint/reflow before we try to scroll
      // - reference: http://stackoverflow.com/a/34999925
      setTimeout(
        window.requestAnimationFrame(function() {
          let el = document.getElementById(hash)
          if (!el) {
            el = document.getElementById(hash.replace('q_', ''))
          }
          if (el) {
            el.scrollIntoView()
            // this adjust the scroll amount to account for our fixed header
            window.scrollBy(0, -45)
          }
          // clean up the hash, so we don't scroll on every prop update
          removeHash(el)
        }),
        0
      )
    }
  }

  // tweaked from http://stackoverflow.com/questions/1397329/how-to-remove-the-hash-from-window-location-with-javascript-without-page-refresh/5298684#5298684
  removeHash(el) {
    const loc = window.location
    const hist = window.history

    // use modern browser history API
    if (hist && 'pushState' in hist) {
      hist.replaceState('', document.title, loc.pathname + loc.search)
      if (el) {
        setTimeout(
          window.requestAnimationFrame(() => {
            if (el.nextSibling && typeof el.nextSibling !== 'undefined') {
              const sibling = el.nextSibling
              const inputList = sibling.querySelectorAll('input')
              if (inputList && inputList.length > 0) {
                inputList[0].focus()
              }
            }
          })
        )
      }

      // fallback for older browsers
    } else {
      // prevent scrolling by storing the page's current scroll offset
      const scrollV = document.body.scrollTop
      const scrollH = document.body.scrollLeft

      loc.hash = ''

      // restore the scroll offset, should be flicker free
      document.body.scrollTop = scrollV
      document.body.scrollLeft = scrollH
    }
  }

  navigateToTab(zeroBasedNavIndex) {
    const nav = this.props.esdpMap.navigation.topics

    let urlParts = this.props.router.location.pathname
    urlParts = urlParts.split('/')
    urlParts.pop()

    const newUrl = urlParts.join('/') + '/' + nav[zeroBasedNavIndex].id

    this.insights.trackEvent({
      pageName: document.title,
      eventName: 'pageAction',
      actionName:
        zeroBasedNavIndex === 5 ? 'createSummary' : 'inlineNavigation',
      actionContext: nav[zeroBasedNavIndex - 1].title
    })

    this.props.router.push(newUrl)
    window.scrollTo(0, 0)
  }

  onFinishClick() {
    // Expecting leaning questions to always be the fourth item...
    const leaningQuestions = this.props.topic.topics[3]
    if (leaningQuestions) {
      const firstQuestionId = leaningQuestions.content[0].interactions[0].id
      const recordedResponse = this.props.responseState.responses[
        firstQuestionId
      ]
      if (recordedResponse) {
        this.props.updateStatus('Completed')
      } else {
        this.props.updateStatus('Partial')
      }
    }

    // enable Summary tab
    this.props.enableSummary()

    // navigate to Summary tab
    this.navigateToTab(5)
  }

  getButton() {
    const navigateToTab = this.navigateToTab

    switch (this.props.topic.type) {
      case 'esdpHome':
        return (
          <Button role="link" onClick={() => navigateToTab(1)}>
            Next
          </Button>
        )
      case 'esdpFacts':
        return (
          <Button role="link" onClick={() => navigateToTab(2)}>
            Next
          </Button>
        )
      case 'esdpCompare':
        return (
          <Button role="link" onClick={() => navigateToTab(3)}>
            Next
          </Button>
        )
      case 'esdpLearn':
        return (
          <Button role="link" onClick={() => navigateToTab(4)}>
            Next
          </Button>
        )
      case 'esdpDecide':
        return (
          <Button role="link" onClick={() => this.onFinishClick()}>
            Finish
          </Button>
        )
      default:
        return null
    }
  }

  render() {
    let {
      responseState,
      topic,
      navigationInfo,
      resourcesRoot,
      mediaServiceInfo
    } = this.props
    const actionButton = this.getButton()

    // summary topic gets different treatment
    const content =
      topic.type === 'decisionSummary' ? (
        <SummaryPage {...this.props} />
      ) : (
        topic.topics.map((contentItem, index) => {
          return (
            <Content
              key={contentItem.id}
              sectionIndex={index}
              item={contentItem}
              responseState={responseState}
              actionButtons={actionButton}
              navigationInfo={navigationInfo}
              resourcesRoot={resourcesRoot}
              mediaServiceUrl={mediaServiceInfo.mediaServiceUrl}
              mediaHash={mediaServiceInfo.mediaHash}
              mediaToken={mediaServiceInfo.mediaToken}
            />
          )
        })
      )

    return <ContentArticle>{content}</ContentArticle>
  }
}

Topic.propTypes = {
  router: PropTypes.object,
  esdpMap: PropTypes.object,
  mediaServiceInfo: PropTypes.object,
  responseState: PropTypes.object,
  navigationInfo: PropTypes.array,
  updateStatus: PropTypes.func.isRequired,
  enableSummary: PropTypes.func,
  resourcesRoot: PropTypes.string,
  topic: PropTypes.shape({
    topics: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        content: PropTypes.arrayOf(
          PropTypes.shape({
            interactions: PropTypes.arrayOf(
              PropTypes.shape({
                id: PropTypes.string.isRequired
              })
            )
          })
        )
      })
    ).isRequired,
    title: PropTypes.shape({
      consumer: PropTypes.string
    }).isRequired,
    type: PropTypes.string
  }).isRequired
}

export default Topic



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/Topic/index.js